import React from 'react';
import moment from 'moment';
import { formatToBRL } from '../../../../utils/formatter';
import { ExtratoDescritivoScroll } from './ExtratoReportStyles';

function formatEndereco(solicitacao) {
  const loc = solicitacao && solicitacao.locacao;
  const arr = loc && loc.endereco;
  const e = arr && arr[0];
  if (!e) return '-';
  const parts = [];
  if (e.logradouro) parts.push(`${e.logradouro}.`);
  if (e.numero) parts.push(`${e.numero}.`);
  if (e.complemento) parts.push(`${e.complemento}.`);
  if (e.bairro) parts.push(`${e.bairro}.`);
  if (e.cidade) parts.push(`${e.cidade}.`);
  if (e.uf) parts.push(`${e.uf}.`);
  return parts.join(' ') || '-';
}

function codImovel(solicitacao) {
  const loc = solicitacao && solicitacao.locacao;
  const c = loc && loc.codigo_imovel;
  if (!c && c !== 0) return '-';
  return `#${String(c).replace(/^#/, '')}`;
}

function insidePeriod(paymentAt, startIso, endIso) {
  if (!paymentAt) return false;
  const p = moment(paymentAt);
  return p.isAfter(moment(startIso)) && p.isBefore(moment(endIso));
}

function hasPaidOriginal(produtosOriginal) {
  return (produtosOriginal || []).some((p) => p.status !== 'INCLUIDO' && p.status !== 'REINCLUIDO');
}

function SolicitacaoBloco({ solicitacao, resume, pagamentoAVista }) {
  const isMobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 800px)').matches;
  const start = resume.resumo.periodo.start_date;
  const end = resume.resumo.periodo.end_date;
  const produtosMap = resume.resumo.produtos || {};

  const pretendentes = Array.isArray(solicitacao.pretendentes) ? solicitacao.pretendentes : [];

  return (
    <div
      style={{
        fontSize: 12,
        color: '#263238',
        padding: '12px 14px 14px',
        marginBottom: 14,
        border: '1px solid #e0e0e0',
        borderRadius: 6,
        borderLeft: '4px solid #1565c0',
        background: '#fafbfc',
      }}
    >
      <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, marginBottom: 12, tableLayout: 'fixed' }}>
        <tbody>
          {isMobile ? (
            <>
              <tr>
                <td style={{ paddingRight: 0, verticalAlign: 'top' }}>
                  <span style={{ display: 'block', fontSize: 9, fontWeight: 600, letterSpacing: '0.06em', color: '#78909c', textTransform: 'uppercase', marginBottom: 4 }}>Nº da solicitação</span>
                  <span style={{ fontWeight: 600, color: '#111' }}>#{solicitacao.id}</span>
                </td>
              </tr>
              <tr>
                <td style={{ paddingTop: 8, paddingRight: 0, verticalAlign: 'top' }}>
                  <span style={{ display: 'block', fontSize: 9, fontWeight: 600, letterSpacing: '0.06em', color: '#78909c', textTransform: 'uppercase', marginBottom: 4 }}>Código do imóvel</span>
                  <span style={{ fontWeight: 600, color: '#111' }}>{codImovel(solicitacao)}</span>
                </td>
              </tr>
              <tr>
                <td style={{ paddingTop: 8, verticalAlign: 'top' }}>
                  <span style={{ display: 'block', fontSize: 9, fontWeight: 600, letterSpacing: '0.06em', color: '#78909c', textTransform: 'uppercase', marginBottom: 4 }}>Endereço</span>
                  <span style={{ fontWeight: 600, color: '#111', lineHeight: 1.4 }}>{formatEndereco(solicitacao)}</span>
                </td>
              </tr>
            </>
          ) : (
            <tr>
              <td style={{ width: '15%', paddingRight: 14, verticalAlign: 'top' }}>
                <span style={{ display: 'block', fontSize: 9, fontWeight: 600, letterSpacing: '0.06em', color: '#78909c', textTransform: 'uppercase', marginBottom: 4 }}>Nº da solicitação</span>
                <span style={{ fontWeight: 600, color: '#111' }}>#{solicitacao.id}</span>
              </td>
              <td style={{ width: '18%', paddingRight: 14, verticalAlign: 'top' }}>
                <span style={{ display: 'block', fontSize: 9, fontWeight: 600, letterSpacing: '0.06em', color: '#78909c', textTransform: 'uppercase', marginBottom: 4 }}>Código do imóvel</span>
                <span style={{ fontWeight: 600, color: '#111' }}>{codImovel(solicitacao)}</span>
              </td>
              <td style={{ verticalAlign: 'top' }}>
                <span style={{ display: 'block', fontSize: 9, fontWeight: 600, letterSpacing: '0.06em', color: '#78909c', textTransform: 'uppercase', marginBottom: 4 }}>Endereço</span>
                <span style={{ fontWeight: 600, color: '#111', lineHeight: 1.4 }}>{formatEndereco(solicitacao)}</span>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {pretendentes.map((pret) => {
        const orig = (pret.produtos && pret.produtos.original) || [];
        const rec = (pret.produtos && pret.produtos.reconsulta) || [];
        if (!hasPaidOriginal(orig)) return null;

        const recPagas = (rec || []).filter((r) => r.status !== 'INCLUIDO' && r.status !== 'REINCLUIDO');

        const rows = [];

        orig.forEach((o) => {
          const bold = insidePeriod(o.data_pagamento, start, end);
          const unit = produtosMap[o.nome] && produtosMap[o.nome].produto_valor_unitario;
          rows.push(
            <tr key={`o-${o.id || o.pretendente_produto_id}`}>
              <td style={{ ...tdBase, fontWeight: 600, color: '#1a237e', width: pagamentoAVista ? '22%' : '35%' }}>{pret.oculto ? 'IDENTIFICAÇÃO OCULTADA' : pret.nome}</td>
              <td style={{ ...tdBase, width: pagamentoAVista ? '28%' : '40%' }}>
                <div style={{ fontWeight: bold ? 700 : 600, color: '#263238' }}>{o.usuario_solicitante}</div>
                <div style={{ fontSize: 10, color: '#607d8b', marginTop: 3 }}>{o.data_pagamento ? moment(o.data_pagamento).format('DD/MM/YYYY HH:mm') : ''}</div>
              </td>
              <td style={{ ...tdBase, textAlign: 'right', width: pagamentoAVista ? '18%' : '25%', fontWeight: bold ? 700 : 600 }}>{o.nome}</td>
              {pagamentoAVista ? (
                <React.Fragment>
                  <td style={{ ...tdBase, textAlign: 'center', width: '14%', fontWeight: bold ? 700 : 600 }}>{o.cobranca_id || '-'}</td>
                  <td style={{ ...tdBase, textAlign: 'right', width: '18%', fontWeight: bold ? 700 : 600 }}>{unit !== undefined ? `R$ ${formatToBRL(unit)}` : '-'}</td>
                </React.Fragment>
              ) : null}
            </tr>
          );
        });

        recPagas.forEach((r) => {
          const bold = insidePeriod(r.data_pagamento, start, end);
          rows.push(
            <tr key={`r-${r.id || r.pretendente_produto_id}`}>
              <td style={{ ...tdBase, fontWeight: 600, color: '#1a237e', width: pagamentoAVista ? '22%' : '35%' }}>{pret.oculto ? 'IDENTIFICAÇÃO OCULTADA' : pret.nome}</td>
              <td style={{ ...tdBase, width: pagamentoAVista ? '28%' : '40%' }}>
                <div style={{ fontWeight: bold ? 700 : 600, color: '#263238' }}>{r.usuario_solicitante}</div>
                <div style={{ fontSize: 10, color: '#607d8b', marginTop: 3 }}>{r.data_pagamento ? moment(r.data_pagamento).format('DD/MM/YYYY HH:mm') : ''}</div>
              </td>
              <td style={{ ...tdBase, textAlign: 'right', fontWeight: bold ? 700 : 600 }}>{r.nome}</td>
              {pagamentoAVista ? (
                <React.Fragment>
                  <td style={{ ...tdBase, textAlign: 'center', fontWeight: bold ? 700 : 600 }}>-</td>
                  <td style={{ ...tdBase, textAlign: 'right', fontWeight: bold ? 700 : 600 }}>-</td>
                </React.Fragment>
              ) : null}
            </tr>
          );
        });

        return (
          <div key={pret.id} style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <table style={{ width: '100%', minWidth: pagamentoAVista ? 560 : 400, borderCollapse: 'collapse', tableLayout: 'fixed', fontSize: 11, marginBottom: 8 }}>
            <thead>
              <tr>
                <th style={thBase}>Pretendente</th>
                <th style={thBase}>Quem solicitou e data</th>
                <th style={{ ...thBase, textAlign: 'right' }}>Produto</th>
                {pagamentoAVista ? (
                  <React.Fragment>
                    <th style={{ ...thBase, textAlign: 'center', width: '14%' }}>Id cobrança</th>
                    <th style={{ ...thBase, textAlign: 'right', width: '18%' }}>Valor unit.</th>
                  </React.Fragment>
                ) : null}
              </tr>
            </thead>
            <tbody>{rows}</tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
}

const thBase = {
  fontWeight: 600,
  textAlign: 'left',
  padding: '7px 6px',
  border: '1px solid #cfd8dc',
  borderBottom: '2px solid #b0bec5',
  background: '#eceff1',
  color: '#37474f',
  fontSize: 10,
};

const tdBase = {
  padding: '7px 6px',
  border: '1px solid #e0e0e0',
  borderTop: 'none',
  verticalAlign: 'top',
  lineHeight: 1.35,
  background: '#fff',
};

export default function ExtratoDescritivoSection({ resume, solicitacoes, hasFiltered }) {
  if (!hasFiltered || !resume || !resume.resumo || !resume.resumo.periodo) {
    return null;
  }

  const list = Array.isArray(solicitacoes) ? solicitacoes : [];
  const pagamentoAVista = !!resume.a_vista;

  return (
    <div>
      <ExtratoCardTitleLocal />
      <p style={{ fontSize: 12, color: '#546e7a', textAlign: 'center', margin: '-6px 0 12px', lineHeight: 1.4 }}>Detalhamento das análises e cobranças por solicitação no período.</p>
      <ExtratoDescritivoScroll>
        {list.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 22, color: '#78909c', fontSize: 12, border: '1px dashed #cfd8dc', borderRadius: 8, background: '#fafafa' }}>
            Nenhuma análise com cobrança registrada neste período.
          </div>
        ) : (
          list.map((sol) => <SolicitacaoBloco key={sol.id} solicitacao={sol} resume={resume} pagamentoAVista={pagamentoAVista} />)
        )}
      </ExtratoDescritivoScroll>
    </div>
  );
}

function ExtratoCardTitleLocal() {
  return (
    <h2
      style={{
        fontSize: 15,
        fontWeight: 600,
        letterSpacing: '0.06em',
        textAlign: 'center',
        margin: '0 0 8px',
        color: '#1565c0',
      }}
    >
      DESCRITIVO
    </h2>
  );
}
